import { Calendly, Github, Instagram, Linkedin, Tiktok, X } from 'components/icons/v2/social';
import React from 'react';

export type SocialType = 'X' | 'instagram' | 'linkedin' | 'tiktok' | 'github' | 'calendly';


export const GetSocialIcon = (iconName: SocialType, iconSize: number) => {
  switch (iconName) {
    case 'X':
      return <X width={iconSize} height={iconSize} />;
    case 'linkedin':
      return <Linkedin width={iconSize} height={iconSize} />;
    case 'instagram':
      return <Instagram width={iconSize} height={iconSize} />;
    case 'tiktok':
      return <Tiktok width={iconSize} height={iconSize} />;
    case 'github':
      return <Github width={iconSize} height={iconSize} />;
    case 'calendly':
      return <Calendly width={iconSize} height={iconSize} />;
  }
};